<template>
  <Tile class="opc-event-services">
    <Foldable v-model="isExpanded" :title="title" :edit="false" :arrow="false" :titleAriaHidden='true'>
      <template #head>
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title" tabindex="-1" />
          </div>
          <div class="opc-zm-base-card__head-right">
            <h2 class="opc-zm-base-card__name">
              {{ title }}
              <i class="zm-icon-success main-icon" aria-hidden="true" />
            </h2>
          </div>
        </div>
      </template>

      <div class="divide-line" />

      <div class="opc-event-services__main">
        <div class="opc-event-services__desc">{{ $t('billing.event_services.desc') }}</div>
        <div class="opc-event-services__terms">
          <div lass="opc-event-services__terms__content-wrap" >
            <!-- Ax issue fix: The ternary expression will be read multiple times in voiceOver,
            so split it up and refocus after switching the button.  -->
            <zm-button
              v-if='termsIsExpanded'
              data-testid="checkout-button-64"
              ref='hideTerms'
              key='hideTerms'
              class="opc-event-services__terms__toggle-btn"
              type="link"
              :aria-label='termsAriaLabel'
              aria-expanded="true"
              aria-live="assertive"
              @click='handleExpandTerms'
            >
              {{$t('billing.event_services.hide_terms')}}
            </zm-button>
            <zm-button
              v-else
              data-testid="checkout-button-65"
              ref='viewTerms'
              key='viewTerms'
              class="opc-event-services__terms__toggle-btn"
              type="link"
              :aria-label='termsAriaLabel'
              aria-expanded="false"
              @click='handleExpandTerms'
            >
              {{$t('billing.event_services.view_terms')}}
            </zm-button>
            <div v-if='termsIsExpanded' class="opc-event-services__terms__content" v-html="$t('billing.event_services.terms_content')" />
          </div>
        </div>
      </div>
    </Foldable>
  </Tile>
</template>

<script>
import Tile from '@/components/tile.vue'
import Foldable from '@/components/foldable.vue'
import { mapGetters } from 'vuex';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import plansMixin from "@/plans/mx/plan";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  mixins: [plansMixin],
  components: {
    Tile,
    Foldable,
  },

  data() {
    return {
      isExpanded: true,
      logo: getPlanLogo(planTypes.EVENT_SERVICES),
      title: this.$t('billing.event_services.title'),
      termsIsExpanded: false,
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    hasOneTimeWebinar() {
      return this.getSelectedPlans.find(p => p.type === planTypes.WEBINAR && p.billing_cycle === BILLING_CYCLE.ONE_TIME);
    },
    termsAriaLabel() {
      if (!this.termsIsExpanded) {
        return 'view terms';
      }
      return 'hide terms';
    }
  },
  watch: {
    getSelectedPlans() {
      if (!this.hasOneTimeWebinar) {
        this.removePlanByKey(planTypes.EVENT_SERVICES);
      }
    }
  },
  methods: {
    handleExpandTerms() {
      this.$tracking.buyInteraction(`view terms selected`, `event service consulting for webinars - ${!this.termsIsExpanded ? 'view terms' : 'hide terms'}`);
      this.termsIsExpanded = !this.termsIsExpanded;
      this.$nextTick(() => {
        if (this.termsIsExpanded) {
          this.$refs.hideTerms.$el.focus();
        } else {
          this.$refs.viewTerms.$el.focus();
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.opc-event-services {
  &__desc {
    font-size: 14px;
    line-height: 1.5;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }
  &__terms {
    margin-top: 16px;
    &__toggle-btn {
      padding: 0;
      line-height: 1.5;
    }
    &__content {
      padding-top: 16px;
      font-size: 12px;
      line-height: 1.2;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
  }
}
</style>
